import { makeStyles } from '@material-ui/styles';

export const useStyles = makeStyles((theme) => ({
  root: {
    width: '100%',
    maxWidth: 980,
    margin: '0 auto',
    padding: theme.spacing(3),
    [theme.breakpoints.down('sm')]: {
      padding: theme.spacing(2),
    },
  },
  title: {
    fontSize: 28,
    fontWeight: 700,
    color: '#0B1736',
    marginBottom: theme.spacing(1),
    [theme.breakpoints.down('sm')]: {
      fontSize: 22,
    },
  },
  subtitle: {
    color: '#5F7394',
    marginBottom: theme.spacing(3),
    [theme.breakpoints.down('sm')]: {
      fontSize: 14,
    },
  },
  card: {
    background: '#FFFFFF',
    border: '1px solid #E2E8F0',
    borderRadius: 16,
    padding: theme.spacing(4),
    marginBottom: theme.spacing(3),
    minHeight: 320,
    alignItems: 'center',
    display: 'flex',
    flexDirection: 'column',
    justifyContent: 'center',
    [theme.breakpoints.down('sm')]: {
      padding: theme.spacing(2),
      minHeight: 'auto',
    },
  },
  row: {
    display: 'flex',
    flexWrap: 'nowrap',
    justifyContent: 'center',
    gap: theme.spacing(1.5),
    marginBottom: theme.spacing(2),
    overflowX: 'auto',
    paddingBottom: theme.spacing(1),
    [theme.breakpoints.down('sm')]: {
      gap: theme.spacing(1),
      width: '100%',
    },
  },
 digitField: {
  width: 52,

  [theme.breakpoints.down('sm')]: {
    width: 32,
  },

  '& input': {
    textAlign: 'center',
    fontSize: 24,
    fontWeight: 700,
    padding: theme.spacing(1.4, 0),

    [theme.breakpoints.down('sm')]: {
      fontSize: 18,
      padding: theme.spacing(0.8, 0),
    },
  },
},
  codeHint: {
    color: '#5F7394',
    marginBottom: theme.spacing(2),
  },
  actions: {
    display: 'flex',
    justifyContent: 'flex-end',
    gap: theme.spacing(1.5),
    marginTop: theme.spacing(2),
  },
  buttons: {
    display: 'flex',
    justifyContent: 'space-between',
    padding: 5,
    '& button': {
      width: 114,
      height: 31,
      backgroundColor: 'transparent',
      color: '#000000',
      fontSize: 14,
      fontWeight: 600,
      border: 'none',
      outline: 'none',
      borderRadius: 4,
      border: '1px solid #2DCE98',
      display: 'flex',
      alignItems: 'center',
      justifyContent: 'center',
      textTransform: 'uppercase',
      cursor: 'pointer',
    },
  },
  buttonsActive: {
    backgroundColor: '#2DCE98 !important',
    color: '#fff !important',
  },
  secondaryButton: {
    background: '#FFFFFF',
    border: '1px solid #D7DFEC',
    color: '#0B1736',
    borderRadius: 10,
    fontWeight: 700,
    minWidth: 120,
  },
  primaryButton: {
    background: '#0B1736',
    color: '#FFFFFF',
    borderRadius: 10,
    fontWeight: 700,
    minWidth: 160,
    '&:hover': {
      background: '#12214A',
    },
  },
  actionButton: {
    minWidth: 220,
  },
  validatedBox: {
    background: '#ECFDF3',
    border: '1px solid #ABEFC6',
    color: '#027A48',
    borderRadius: 12,
    padding: theme.spacing(2),
    marginBottom: theme.spacing(2),
    fontWeight: 600,
  },
  meta: {
    color: '#344054',
    marginBottom: theme.spacing(0.8),
  },
}));
